import * as actionTypes from './actionTypes';

import { createActionObject, getAjaxFunc, getNoArgDispatcherFunc, getStationTime } from '../../helpers/common';
import * as strings from '../../helpers/strings';
import { downloadRequest as downloadRequestSchema, arrayOfDownloadRequest, normalize } from '../../helpers/schema';
import * as slowDataApi from '../../slow-data/api';
import { GENERATED } from '../constants';
import { snackBarVisiblePeriod } from '../../helpers/constants';

import * as api from '../api';
import JSZip from 'jszip';

export const fetchUserDownloadRequests = userId => dispatch => getAjaxFunc(
  actionTypes.FETCH_USER_DOWNLOAD_REQUESTS_REQUEST,
  "",
  actionTypes.FETCH_USER_DOWNLOAD_REQUESTS_FAILURE,
  strings.msgUnknownErrorOccured,
  dispatch
)(
  () => api.fetchUserDownloadRequests(userId)
    .then(({ data, status }) => {
      switch (status) {
        case 200:
          dispatch(
            createActionObject(
              actionTypes.FETCH_USER_DOWNLOAD_REQUESTS_SUCCESS,
              normalize(data, arrayOfDownloadRequest)
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.FETCH_USER_DOWNLOAD_REQUESTS_FAILURE,
              { message: strings.msgUnknownErrorOccured }
            )
          );
          break;
      }
    })
)()

export const fetchDownloadAvaliableTime = stnName => dispatch => getAjaxFunc(
  actionTypes.DOWNLOAD_AVALIABLE_TIME,
  "",
  actionTypes.DOWNLOAD_AVALIABLE_TIME_FAIL,
  strings.msgUnknownErrorOccured,
  dispatch
)(
  () => api.downloadTime(stnName)
    .then(({ data, status }) => {
      switch (status) {
        case 200:
          dispatch(
            createActionObject(
              actionTypes.DOWNLOAD_AVALIABLE_TIME_SUCCESS,
              {data: data}
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.DOWNLOAD_AVALIABLE_TIME_FAIL,
              { message: strings.msgUnknownErrorOccured }
            )
          );
          break;
      }
    })
)()

export const createDownloadRequest = (downloadRequest, stationTimeOffset) => dispatch => getAjaxFunc(
  actionTypes.CREATE_DOWNLOAD_REQUEST_REQUEST,
  "",
  actionTypes.CREATE_DOWNLOAD_REQUEST_FAILURE,
  strings.msgUnknownErrorOccured,
  dispatch
)(
  () => {
    downloadRequest.displayStartDate = downloadRequest.startDate;
    downloadRequest.displayEndDate = downloadRequest.endDate;

    downloadRequest.startDate = getStationTime(new Date(downloadRequest.startDate), stationTimeOffset)
      .getTime();
    downloadRequest.endDate = getStationTime(new Date(downloadRequest.endDate), stationTimeOffset)
      .getTime();

    return api.createDownloadRequest(downloadRequest)
      .then(({ data, status }) => {
        switch (status) {
          case 200:
            dispatch(
              createActionObject(
                actionTypes.CREATE_DOWNLOAD_REQUEST_SUCCESS,
                normalize(data, downloadRequestSchema)
              )
            );
            break;
          default:
            dispatch(
              createActionObject(
                actionTypes.CREATE_DOWNLOAD_REQUEST_FAILURE,
                { message: strings.msgUnknownErrorOccured }
              )
            );
            break;
        }
      });
  }
)()

export const deleteDownloadRequest = (downloadRequestId, index) => dispatch => getAjaxFunc(
  actionTypes.DELETE_DOWNLOAD_REQUEST_REQUEST,
  "",
  actionTypes.DELETE_DOWNLOAD_REQUEST_FAILURE,
  strings.msgUnknownErrorOccured,
  dispatch
)(
  () => api.downloadRequest(downloadRequestId)
    .then(({ status }) => {
      switch (status) {
        case 200:
          dispatch(
            createActionObject(
              actionTypes.DELETE_DOWNLOAD_REQUEST_SUCCESS,
              { index }
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.DELETE_DOWNLOAD_REQUEST_FAILURE,
              { message: strings.msgUnknownErrorOccured }
            )
          );
          break;
      }
    })
)()

export const downloadFile = fileName => dispatch => getAjaxFunc(
  actionTypes.DOWNLOAD_FILE_REQUEST,
  "",
  actionTypes.DOWNLOAD_FILE_FAILURE,
  strings.msgUnknownErrorOccured,
  dispatch
)(
  () => api.downloadFile(fileName)
    .then(blob => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([blob], { type: "application/octet-stream" })

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers: 
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement('a');
      link.href = data;
      link.download = fileName;
      link.click();
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);

      dispatch(
        createActionObject(
          actionTypes.DOWNLOAD_FILE_SUCCESS
        )
      )
    })
)()

export const fetchByIds = ids => dispatch => getAjaxFunc(
  actionTypes.FETCH_BY_IDS_REQUEST,
  "",
  actionTypes.FETCH_BY_IDS_FAILURE,
  strings.msgUnknownErrorOccured,
  dispatch
)(
  () => api.fetchByIds(ids)
    .then(({ status, data }) => {
      switch (status) {
        case 200:
          dispatch(
            createActionObject(
              actionTypes.FETCH_BY_IDS_SUCCESS,
              normalize(data, arrayOfDownloadRequest)
            )
          );
          const count = data.filter(downloadRequest => downloadRequest.status === GENERATED).length;
          if (count) {
            dispatch(
              createActionObject(
                actionTypes.OPEN_SNACK_BAR,
                { message: strings.msgDownloadReady }
              )
            );
            setTimeout(() => {
              dispatch(
                createActionObject(
                  actionTypes.CLOSE_SNACK_BAR
                )
              );
            }, snackBarVisiblePeriod)
          }
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.FETCH_BY_IDS_FAILURE
            )
          );
          break;
      }
    })
)();

export const setFetchInterval = interval => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_FETCH_INTERVAL,
    { interval }
  )
)

export const clearFetchInterval = getNoArgDispatcherFunc(actionTypes.CLEAR_FETCH_INTERVAL)


// DOWNLOAD DATA ACTIONS

export const setSelectDownloadDataStation = stationName => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_DOWNLOAD_DATA_STATION,
    { stationName }
  )
);

export const setCurrentDownloadDataStation = stationName => dispatch => dispatch(
  createActionObject(
    actionTypes.CURRENT_DOWNLOAD_DATA_STATION,
    { stationName }
  )
);

export const resetSelectDownloadDataStation = () => dispatch => dispatch(
  createActionObject(
    actionTypes.RESET_DOWNLOAD_DATA_STATION,
    { data: "" }
  )
);

export const setSelectDownloadDataYear = year => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_DOWNLOAD_DATA_YEAR,
    { year }
  )
);

export const setSelectDownloadDataMonth = month => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_DOWNLOAD_DATA_MONTH,
    { month }
  )
);

export const loadYears = () => dispatch => getAjaxFunc(
  actionTypes.LOAD_YEARS_REQUEST,
  "",
  actionTypes.LOAD_YEARS_FAILURE,
  "",
  dispatch
)(
  () => slowDataApi.loadYearIndices()
    .then(({ data, status }) => {
      switch (status) {
        case 200:
          dispatch(
            createActionObject(
              actionTypes.LOAD_YEARS_SUCCESS,
              { years: data }
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.LOAD_YEARS_FAILURE
            )
          );
          break;
      }
    })
)()

export const loadYearIndices = () => dispatch => getAjaxFunc(
  actionTypes.FETCH_YEAR_INDICES_REQUEST,
  "",
  actionTypes.FETCH_YEAR_INDICES_FAILURE,
  "",
  dispatch
)(
  () => slowDataApi.loadYearIndices()
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(
          createActionObject(
            actionTypes.FETCH_YEAR_INDICES_SUCCESS,
            { yearIndices: data }
          )
        )
      }
    })
)();

export const callCheckDownloadDataObjectApi = (payload) => dispatch => {
  api.checkDownloadDataObject(payload)
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(
          createActionObject(
            actionTypes.CHECK_DOWNLOAD_DATA_OBJECT,
            { data: data }
          )
        )
        // console.log("Data from API:", data);
      } else if (status === 500) {
        dispatch(
          createActionObject(
            actionTypes.CHECK_DOWNLOAD_DATA_OBJECT,
            { data: null }
          )
        )
      }
    });
};


export const callListDownloadDataObjectApi = (payload) => dispatch => {
  api.listDownloadDataObject(payload)
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(
          createActionObject(
            actionTypes.LIST_DOWNLOAD_DATA_OBJECT,
            { data: data }
          )
        )
        // console.log("Data from API:", data);
      } else if (status === 500) {
        dispatch(
          createActionObject(
            actionTypes.LIST_DOWNLOAD_DATA_OBJECT,
            { data: null }
          )
        )
      }
    });
};

export const callGenerateDownloadDataLinkApi = (payload) => dispatch => {
  api.generateDownloadDataLink(payload)
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(
          createActionObject(
            actionTypes.GENERATE_DOWNLOAD_DATA_LINK,
            { data: data }
          )
        );

        // Create a new zip archive
        const zip = new JSZip();

        // Extract StationName from the file path
        const stationName = payload.fileList[0].split("/")[0]; // Assuming fileList is not empty

        // Use Promise.all to wait for all fetch calls to complete
        Promise.all(
          data.downloadDataLinks.map(fileObject =>
            fetch(fileObject.downloadDataLink)
              .then(response => response.blob())
              .then(blob => zip.file(fileObject.fileName, blob))
          )
        )
        .then(() => {
          // Generate the zip file and trigger the download
          zip.generateAsync({ type: "blob" })
            .then(content => {
              // Combine StationName, CurrentDate, and "Download_Data" to form the zip file name
              const zipFileName = `SERIS_Download_Data_${stationName}.zip`;

              const zipFile = new File([content], zipFileName, { type: "application/zip" });

              // Trigger the download
              const url = window.URL.createObjectURL(zipFile);
              const a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              a.href = url;
              a.download = zipFileName;
              a.click();
              window.URL.revokeObjectURL(url);
            })
            .catch(error => {
              console.error("Error generating zip file:", error);
            });
        })
        .catch(error => {
          console.error("Error fetching file data:", error);
        });
      } else if (status === 500) {
        dispatch(
          createActionObject(
            actionTypes.GENERATE_DOWNLOAD_DATA_LINK,
            { data: null }
          )
        );
      }
    })
    .catch(error => {
      console.error("Error downloading data:", error);
    });
};

export const clearSelectedFiles = () => dispatch => dispatch(
  createActionObject(
    actionTypes.CLEAR_SELECTED_FILES
  )
);
// END DOWNLOAD DATA ACTIONS